import React from "react"
import PageTitle from "./pageTitle"
import { ReactLenis } from "@studio-freight/react-lenis"
import PageTransition from "./pageTransition"
import ContactOverlay from "./contactOverlay"
import { useLocation } from "@reach/router"
import ScrollObserver from "./scrollObserver"
import MobileMenu from "./mobileMenu"
import Preloader from "./preloader"
import Header from "./header"
import Footer from "./footer"
import Idle from "./idle"

import "../scss/site.scss"

const SCROLL_OPTIONS = {
  duration: 1.2,
  orientation: "vertical",
  easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
  wheelMultiplier: 1,
  smoothTouch: false,
}

export default function Layout({ children, pageContext }) {
  const { pathname } = useLocation()
  return (
    <ReactLenis root options={SCROLL_OPTIONS}>
      <ScrollObserver />
      <PageTitle />
      <Idle />
      <Header />
      <MobileMenu />
      <ContactOverlay />
      {(pathname === "/" && <Preloader />)}
      <PageTransition>
        <main>{children}</main>
        <Footer />
      </PageTransition>
    </ReactLenis>
  )
}
